/* eslint-disable no-console */
import { gridConfig, GridContainer, GridItem, GridRow } from '@tvg/fuse/grid';
import { EUserAction } from 'client/config';
import useMediaQuery from 'client/hooks/useMediaQuery';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import useSSR from 'use-ssr';

import { parsePLPURL } from '@tvg/product-listing-url';
import { useMainState } from 'client/state/Main';
import { isIosApp, isIosSafari } from '../../utils/utils';
import CardGrid from '../CardGrid';
import { Drawer } from '../Drawer/Drawer';
import Facet from '../Facet';
import { Spinner } from '../Spinner/Spinner';
import Events from './Events';
import styles from './Main.module.css';

function Main() {
  const setLastAction = useMainState((s) => s.setLastAction);
  const setPLPURL = useMainState((s) => s.setPLPURL);
  const { isBrowser } = useSSR();

  const isDesktop = useMediaQuery(`(min-width: ${gridConfig.l.minWidth})`);

  useEffect(() => {
    // eslint-disable-next-line no-underscore-dangle
    window._uxa = window._uxa || [];
    try {
      // eslint-disable-next-line no-underscore-dangle
      window._uxa.push(['setCustomVariable', 17, 'tvgPlatform', 'skyscape', 3]);
    } catch (error) {
      /* istanbul ignore next */
      console.log('Error creating Content Square custom variable: ', error);
    }
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      setPLPURL(parsePLPURL(`${window.location.pathname}${window.location.search}`));
      setLastAction(EUserAction.BROWSER_ACTION);

      // Fixing back button journey for Safari SPA
      if (isDesktop || (!isIosSafari() && !isIosApp())) {
        return;
      }

      // Forcing a scroll up and down to re-paint product cards
      const yPosition = window.scrollY || window.pageYOffset;
      window.scrollTo(0, yPosition - 1);

      setTimeout(() => {
        window.scrollTo(0, yPosition + 1);
        window.scrollTo(0, yPosition);
      }, 10);
    };

    window.addEventListener('popstate', handlePopState);
    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [setLastAction, setPLPURL]);

  useEffect(() => {
    const userIdFromCookie = Cookies.get('COID');
    if (userIdFromCookie) {
      window.cnstrcUserId = userIdFromCookie as string;
    }
  }, []);

  return (
    <GridContainer className={styles.main}>
      <GridRow className={styles.main__content}>
        <Facet />

        <GridItem xxs={12} l={9} className="grid-item">
          <CardGrid />
        </GridItem>
      </GridRow>
      {isBrowser && !isDesktop && (
        <>
          <Spinner />
          <Drawer />
        </>
      )}
      <Events />
    </GridContainer>
  );
}

export default React.memo(Main);
